﻿import { inductryMaster } from './InductryMasterModel';

export class hazardMaster {
    hazardMasterId: string;
    hazardName: string;
    industryId: string;
    isActive: string;
    displayOrder: string;
    createdDate: string;
    createdBy: string;
    modifiedDate: string;
    modifiedBy: string;
    isSelected: boolean = false;
    totalRecords: string;
    encryHazardMasterId: string;
    industryList: inductryMaster[];
}